
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { message, Collapse, Button, Modal } from 'antd';
import { RiUserSettingsLine } from 'react-icons/ri';
import { IoIosTimer } from 'react-icons/io';
import { AiOutlineFileSearch, AiOutlineFire } from 'react-icons/ai';
import { CampaignGetSingle } from '../../apis/Influencer/Campaigns/CampaignGetSingle';
import { useGlobalState } from '../../store/state';
import InfluencerBaseLayoutComponent from '../../components/Layout/Influencer/InfluencerBaseLayoutComponent';
import InfluencerTopSubHeaderComponent from '../../components/Influencers/Common/InfluencerTopSubHeaderComponent';
import CampaignBaseDetailsComponent from '../../components/Influencers/Campaign/Details/CampaignBaseDetailsComponent';
import CampaignScheduleComponent from '../../components/Influencers/Campaign/Details/CampaignScheduleComponent';
import CampaignBriefComponent from '../../components/Influencers/Campaign/Details/CampaignBriefComponent';
import CreativeCardsPreview from '../../components/Influencers/Campaign/Details/CreativeCardsPreview';
import './InfluencerCampaignDetailsPage.styles.scss';
import { AcceptCampaign } from '../../apis/Influencer/Campaigns/AcceptCampaign';
import { DeclineCampaign } from '../../apis/Influencer/Campaigns/DeclineCampaign';
import CampaignProgressComponent from '../../components/Influencers/Campaign/Details/CampaignProgressComponent';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Panel } = Collapse;
const InfluencerCampaignDetailsPage = () => {
  const history = useHistory();
  const params = useParams();
  const [user] = useGlobalState('user');
  const [camp, setCamp] = useState({});
  const getCampaignDetails = () =>{
    CampaignGetSingle(
      user.accessToken,
      params.campaignId,
    ).then(({ status, response })=>{
      console.log('API: res-> campaign single ==>', response);
      if (status === 200) {
        setCamp({
          ...response,
        });
      } else {
        message.error('There is some error in getting Campaign list');
      }
    });
  };
  useEffect(() =>{ // load all list first time
    getCampaignDetails();
  }, []);

  // @note: user accepting campaign
  const acceptCamp = () =>{
    AcceptCampaign(user.accessToken, {
      campaignid: camp.campaignInfo._id,
    }).then(({ status, response })=>{
      console.log('API: accept Campaign res ==> ', response);
      if (status === 200) {
        console.log('here need to right logic for showing progress card');
      } else {
        message.error('There is some issue with accepting this campaign');
      }
    });
  };

  // @note: user Decline campaign
  const declineCamp = () =>{
    DeclineCampaign(user.accessToken, {
      campaignid: camp.campaignInfo._id,
    }).then(({ status, response })=>{
      console.log('API: accept Campaign res ==> ', response);
      if (status === 200) {
        message.info('Campaign Declined');
        history.push('/influencer/campaigns');
      } else {
        message.error('There is some issue with accepting this campaign');
      }
    });
  };

  const goToCreatives = (mode) =>{
    if (mode === 'accepted') {
      Modal.confirm({
        title: 'Before you proceed',
        icon: <ExclamationCircleOutlined />,
        content: (
          <>
            <p>Please submit if you only ready with all the creatives. You're not allowed to do partial submissions</p>
          </>
        ),
        onOk: () =>{
          history.push(`/influencer/campaigns/${camp.campaignInfo._id}/creatives`);
        },
      });
    }
    // else if(mode === "review"){
    //     history.push(`/influencer/campaigns/${camp.campaignInfo._id}/creatives/review`)
    // }else if(mode === "active"){

    // }
    else {
      history.push(`/influencer/campaigns/${camp.campaignInfo._id}/creatives/review`);
    }
  };
  return (
    <InfluencerBaseLayoutComponent>
      <InfluencerTopSubHeaderComponent className="py-2 sticky">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-6">
            <p className="m-0"><strong>Campaign Details</strong></p>
          </div>
          <div className="col-md-6 text-right">
            {
              camp.connectionStatus === 'assigned' ?
                <>
                  <Button className="common_button outlined py-1"
                    title="Accept this campaign"
                    onClick={acceptCamp}>Accept</Button>
                  <Button className="common_button outlined py-1 ml-2"
                    title="Reject this campaign"
                    onClick={declineCamp}>Decline</Button>
                </> :
                null
            }
          </div>
        </div>
      </InfluencerTopSubHeaderComponent>
      <div style={{ padding: 15 }}>
        <div className="campaign_details pt-1">
          <div className="row">
            <div className="col-md-8 pr-2">
              {
                camp.campaignInfo?
                  <Collapse
                    className="acc_campaign mb-2 common_collapse"
                    showArrow={false}
                    defaultActiveKey={[1, 2, 3, 4]}
                  >
                    <Panel showArrow={false}
                      key="1"
                      header={
                        <h3 ><RiUserSettingsLine/> Breif</h3>
                      }
                    >
                      <CampaignBaseDetailsComponent
                        name={camp.campaignInfo.name}
                        companyname={camp.brandInfo.companyname}
                        campId={camp.campaignInfo._id}
                        objective={camp.campaignInfo.objective}
                        creativesCount={camp.campaignInfo.deliverables.length || 'n/a'}
                        posts={camp.campaignInfo.posts}
                        platform={camp.campaignInfo.platform}
                        earnings={camp.campaignInfo.earnings}
                      />
                    </Panel>
                    <Panel showArrow={false}
                      key="2"
                      header={
                        <h3 ><IoIosTimer/> Schedule</h3>
                      }
                    >
                      <CampaignScheduleComponent
                        startdate={camp.campaignInfo.startdate}
                        enddate={camp.campaignInfo.enddate}
                      />
                    </Panel>
                    <Panel showArrow={false}
                      key="3"
                      header={
                        <h3 ><AiOutlineFileSearch/> Campaign Brief</h3>
                      }
                    >
                      <CampaignBriefComponent
                        brief={camp.campaignInfo.brief}
                        hashtags={camp.campaignInfo.hashtags}
                        keywords={camp.campaignInfo.keywords}
                        mentions={camp.campaignInfo.mentions}
                        guidelines={camp.campaignInfo.thingstoavoid}
                        refLinks={camp.campaignInfo.referencelink}
                      />
                    </Panel>
                    <Panel showArrow={false}
                      key="4"
                      header={
                        <h3 ><AiOutlineFire/> Creatives</h3>
                      }
                    >
                      <CreativeCardsPreview
                        deliverables={camp.campaignInfo.deliverables}
                      />
                    </Panel>
                  </Collapse>:
                  <div>No Campaign Details present</div>
              }
            </div>
            <div className="col-md-4 pl-2">
              {
                camp.connectionStatus ?
                  <CampaignProgressComponent
                    name={camp.campaignInfo.name}
                    campId={camp.campaignInfo._id}
                  >
                    {
                      camp.connectionStatus === 'accepted' ?
                        <div className="mb-1">
                          <Button className="common_button w-100 mb-1"
                            onClick={() => goToCreatives(camp.connectionStatus)}>Submit Creatives</Button>
                          <p className="camp_progress--note text-center">Please upload the creatives
                            <span> {moment(camp.campaignInfo.startdate).startOf('minutes').fromNow()}</span>
                          </p>
                        </div>:
                        null
                    }
                    {
                      camp.connectionStatus === 'review' ?
                        <div className="mb-1">
                          <Button className="common_button w-100 mb-1"
                            onClick={() => goToCreatives(camp.connectionStatus)}>Check Submissions</Button>
                          <p className="camp_progress--note text-center">Please upload the creatives
                            <span> {moment(camp.campaignInfo.startdate).startOf('minutes').fromNow()}</span>
                          </p>
                        </div>:
                        null
                    }
                    {
                      camp.connectionStatus === 'active' ?
                        <div className="mb-1">
                          <Button className="common_button w-100 mb-1"
                            onClick={() => goToCreatives(camp.connectionStatus)}>Submit Links</Button>
                        </div>:
                        null
                    }
                  </CampaignProgressComponent>:
                  null
              }
            </div>
          </div>
        </div>
      </div>
    </InfluencerBaseLayoutComponent>
  );
};

export default InfluencerCampaignDetailsPage;
